<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>设置</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">招聘成本</a>
      </a-breadcrumb-item>
      <!-- <a-breadcrumb-item>总报表</a-breadcrumb-item> -->
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideIsAddSet && !hideIsEdit">
      <section class="searchBox" style="padding-left: 2%">
        <span class="addStyle">
          <a-button
            style="margin-right: 20px"
            v-show="!showIsSearch"
            @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button
            style="margin-right: 20px"
            v-show="showIsSearch"
            @click="showIsSearch = false"
            >隐藏更多</a-button
          >
          <a-button
            v-show="showIsSearch"
            @click="hideIsAddSet = !hideIsAddSet"
            style="margin-right: 20px"
            type="primary"
            icon="plus"
            >招聘成本配置</a-button
          >
        </span>
        <span v-show="showIsSearch">
          <label>一级项目：</label>
          <a-select
            :allowClear="true"
            showSearch
            :filterOption="filterOption"
            v-model="selectedOneVal"
            @change="selectedOne"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListOne"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="isShowTwo && showIsSearch">
          <label>省级项目：</label>
          <a-select
            :allowClear="true"
            v-model="selectedTwoVal"
            @change="selectedTwo"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListTwo"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>项目：</label>
          <a-select
            :allowClear="true"
            v-model="selectedThreeVal"
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 160px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in proListThree"
              :key="i"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>结算方式：</label>
          <a-select style="width:150px" v-model="statement_type">
            <a-select-option :value="1">
              出勤天数常规结算
            </a-select-option>
            <a-select-option :value="2">
              出勤天数阶梯结算
            </a-select-option>
            <a-select-option :value="3">
              时新结算
            </a-select-option>
            <a-select-option :value="4">
              订单/工单结算
            </a-select-option>
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>渠道类型：</label>
          <a-radio-group v-model="resume_source">
            <a-radio :value="3">
              玄鸟员工
            </a-radio>
            <a-radio :value="4">
              三方渠道
            </a-radio>
            <a-radio :value="2">
              芜湖招聘部
            </a-radio>
          </a-radio-group>
        </span>
        <span v-show="showIsSearch">
          <label>岗位：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="请选择项目"
            style="width: 150px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in roleList"
              :key="i"
              >{{ item.role_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>公司：</label>
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="请选择公司"
            style="width: 250px"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, i) in thirdList"
              :key="i"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </span>
        <span>
          <label>结算周期：</label>
          <a-radio-group>
            <a-radio :value="1">
              一次性结算
            </a-radio>
            <a-radio :value="2">
              长返
            </a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <div>
            <a-input placeholder="请输入项目名称" v-model="nameSearch" />
          </div>
        </span>
        <span>
          <a-button style="margin-right: 10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
          <!-- <a-button style="margin-left:20px;background:#001529;color:#fff" icon="cloud-download">下载</a-button> -->
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, k) in data" :key="k">
              <td>{{ item.project_name }}</td>
              <td>
                <p v-show="item.resume_source == 2">芜湖招聘部</p>
                <p v-show="item.resume_source == 3">{{ item.role_name }}</p>
                <p v-show="item.resume_source == 4">{{ item.company_name }}</p>
              </td>
              <td>
                <p v-show="item.statement_type == 1">出勤天数常规结算</p>
                <p v-show="item.statement_type == 2">出勤天数阶梯结算</p>
                <p v-show="item.statement_type == 3">时新结算</p>
                <p v-show="item.statement_type == 4">订单/工单结算</p>
              </td>
              <td>
                <p
                  v-show="item.statement_type == 1 || item.statement_type == 2"
                >
                  {{ "出勤" + item.day + "天" }}
                </p>
                <p v-show="item.statement_type == 3">
                  {{ "需满" + Number(item.hour) + "时" }}
                </p>
                <p v-show="item.statement_type == 4">
                  {{ "需满" + Number(item.order) + "单" }}
                </p>
              </td>
              <td>
                <div v-show="item.statement_type == 1">
                  <p>
                    {{ Number(item.service) + "元" }}
                  </p>
                </div>
                <div v-show="item.statement_type == 2">
                  <p v-for="(element, j) in item.step" :key="j">
                    <span>{{
                      +element.min +
                        "-" +
                        element.max +
                        "人／" +
                        Number(element.service) +
                        "元"
                    }}</span>
                  </p>
                </div>
                <div v-show="item.statement_type == 3">
                  <p>
                    {{ Number(item.every_hour) + "元/小时" }}
                  </p>
                </div>
                <div v-show="item.statement_type == 4">
                  <p>
                    {{ Number(item.every_order) + "元/单" }}
                  </p>
                </div>
              </td>
              <td>
                <p v-show="item.statement_cycle == 1">一次性结算</p>
                <p v-show="item.statement_cycle == 2">长返</p>
              </td>
              <td class="operation">
                <a style="color:#67C23A;" @click="editPage(item)">编辑</a>
              </td>
            </tr>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 配置 -->
    <addSetRecruitCost v-show="hideIsAddSet" v-on:hideInAdd="hideInAdd" />
    <!-- 配置 end -->
    <!-- 配置甲方 -->
    <recruitCostSetEdit v-show="hideIsEdit" :editDetails="editDetails" />
    <!-- 配置甲方 end -->
  </div>
</template>
<script>
import axios from "axios";
import addSetRecruitCost from "@/components/manpower/addSetRecruitCost";
import addOwner from "@/components/recruitCost/addOwner";
import recruitCostSetEdit from "@/components/manpower/recruitCostSetEdit";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目",
        "渠道",
        "结算方式",
        "满足条件",
        "结算详情",
        "结算周期",
        "操作"
      ],
      isHideDetails: false,
      details: {},
      nameSearch: "",
      searchDate: "",
      date: null,
      projectList: [],
      employee_type: 0,
      count_data: "",
      hideIsAddSet: false,
      hideIsAddOwner: false,
      proListOne: [],
      proListTwo: [],
      proListThree: [],
      isShowTwo: false,
      selectedOneVal: "",
      selectedTwoVal: "",
      selectedThreeVal: "",
      showIsSearch: false,
      resume_source: "",
      statement_type: "",
      roleList: [],
      thirdList: [],
      hideIsEdit: false,
      editDetails: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro(); //获取项目
    this.getProOne(); //获取一级项目列表
    this.getRole(); //获取岗位
    this.getThirdParty(); //获取三方渠道
  },
  components: {
    addSetRecruitCost,
    recruitCostSetEdit
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getThirdParty() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Reimbursement/getThirdPartByProjectId";
      let pramas = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, pramas).then(res => {
        if (res.data.code == 200) {
          this.thirdList = res.data.data;
          // console.log(this.thirdList);
        }
      });
    },
    getRole() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000,
        role_type: 1
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.roleList = res.data.data.data;
          // console.log(this.roleList);
        }
      });
    },
    selectedOne(id) {
      this.isShowTwo = true;
      this.selectedTwoVal = "";
      this.selectedThreeVal = "";
      this.getProID(id, 1); //获取下级项目
      // console.log(id);
    },
    selectedTwo(id) {
      this.selectedThreeVal = "";
      this.getProID(id, 2); //获取下级项目
    },
    getProOne() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByLevel";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          level: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListOne = res.data.data;
            // console.log(this.proList);
          }
        });
    },
    getProID(id, level) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/projectListByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            if (level == 1) {
              this.proListTwo = res.data.data;
            } else if (level == 2) {
              this.proListThree = res.data.data;
            }
            // console.log(this.proList);
          }
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proListThree = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    editPage(item) {
      this.hideIsEdit = true;
      this.editDetails = item;
      // console.log(item);
    },
    hideInAdd() {
      this.hideIsAddSet = false;
      this.reload();
    },
    dailyPage() {
      let routeUrl = this.$router.resolve({
        path: "/recruitCost/summary"
      });
      window.open(routeUrl.href, "_blank");
    },
    showInUserList() {
      this.hideIsAddSet = false;
      this.hideIsEdit = false;
    },
    on_return() {
      if (window.event.keyCode == 13) {
        this.getData();
      }
    },
    handleSizeChange(e) {
      this.size = e.target.value;
    },
    onChangeDate(date, dateString) {
      this.searchDate = dateString;
      // console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.people + "Recruitment_cost/lists";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.nameSearch,
        token: window.localStorage.getItem("xnwfPcToken"),
        start_date: this.searchDate[0],
        end_date: this.searchDate[1],
        employee_type: this.employee_type
      };
      if (this.searchDate == "") {
        delete params.start_date;
        delete params.end_date;
      }
      axios
        .post(url, params)
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.count_data = res.data.data.count_data;
            console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(val) {
      // this.$router.push({name:"resumeDetails"})
      this.details = val;
      this.isHideDetails = true;
    },
    onReset() {
      this.searchDate = "";
      this.nameSearch = "";
      this.employee_type = 0;
      this.date = undefined;
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .ruzhiTJ {
    display: inline-block;
    li {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .searchStyle {
    > input {
      margin: 0 20px;
      width: 200px;
    }
  }
  .searchBox {
    display: block;
    > span {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 20px;
      > div {
        display: inline-block;
      }
    }
  }
}
</style>
<style lang="less">
.listContainer {
  // .ant-radio-button-wrapper-checked {
  //   border: 1px solid #d9d9d9;
  // }
  // .ant-radio-button-wrapper-checked::before {
  //   opacity: 0;
  //   background-color: #d9d9d9!important;
  // }
  // .ant-radio-button-wrapper-checked{
  //   box-shadow: unset;
  // }

  .addStyle {
    label:frist-child {
      box-shadow: -1px 0 0 0 #1890ff;
    }
  }
}
</style>
